//-----------------------imports-----------------------
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { locationdata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import SearchAppBar from "../../components/common/search";
import { useSelector } from "react-redux";
import {
  SETTINGS_API_02,
  MENUTYPECODE,
  STS,
  LOCATION_API_01,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";

function ViewLocations() {
  //----------------------hooks------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, GROUPCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await externalgetApi(LOCATION_API_01, "get", {
        COMPCODE,
        GROUPCODE,
        USERNAME,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      setFilteredRows(result);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter(
        (item) =>
          item.LOCATION.toLowerCase().includes(searchText.toLowerCase()) ||
          item.LOCCODE.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredRows(filtered);
    }
  }, [searchText, data]);

  //----------------functions--------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const gotToPage = () => {
    navigate("/AddLocations");
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.LOCCODE === id);
      if (selectedItem) {
        navigate(`/AddLocations`, { state: { selectedItem, actionText } });
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (LOCCODE) => handleItemClick(LOCCODE, "Edit"),
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Location</Link>
                <Link underline="none">View Locations</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => gotToPage()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={locationdata.columns}
          rows={filteredRows.map((item) => ({ ...item, id: item.LOCCODE }))}
          menuItems={menuItems}
          tabletitle={locationdata.name}
          gridid="LOCCODE"
        />
      )}
    </div>
  );
}

export default ViewLocations;
